<template>
  <hic-list-page ref="listPage" title="外出就诊" :entities="entities" :condition="condition" @load="page"
    :loading="meta.loading" header-height="3rem" hide-search-dialog keyword-placeholder="床位号、姓名">
    <template slot="buttons">
      <el-button size="small" type="primary" @click="create('new')">新建</el-button>
    </template>
    <template slot="search">
      <el-date-picker size="small" class="left-pad condition-input" v-model="selectDate" @change="changeDate"
        type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
      </el-date-picker>
      <!-- <el-button size="small" type="primary" @click="page()" class="left-pad">搜索</el-button> -->
    </template>
    <el-table-column align="center" label="操作" width="120">
      <template slot-scope="{ row }">
        <!-- <el-row type="flex" align="middle" justify="space-between"> -->
        <el-button @click.native="create('detail', row)" type="primary" size="mini" icon="el-icon-edit" circle
          plain></el-button>
        <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red"
          :title="`确定要删除吗？`" @confirm="del(row)">
          <el-button class="left-pad" slot="reference" type="danger" size="mini" icon="el-icon-delete" circle
            plain></el-button>
        </el-popconfirm>

      </template>
    </el-table-column>

    <el-table-column align="center" label="床位号" prop="bedNo"></el-table-column>
    <el-table-column align="center" label="姓名">
      <template slot-scope="{ row }">
        <b>{{ row.name }}</b>
      </template>
    </el-table-column>
    <el-table-column align="center" label="性别" prop="type" width="80px">    
      <template slot-scope="{ row }">{{ row.gender | dictText("Gender") }}</template>
    </el-table-column>
    <el-table-column align="center" label="年龄" prop="type" width="120px">
      <template slot-scope="{ row }">
        {{ row.age }}
      </template>
    </el-table-column>
    <el-table-column align="center" label="类型" prop="type" width="120px">
      <template slot-scope="{ row }">
        {{ row.type }}
      </template>
    </el-table-column>
    <el-table-column align="center" width="160px" label="外出日期" prop="outDate">
      <template slot-scope="{ row }">{{ row.outDate | fmtDatetime  }}</template>
    </el-table-column>
    <el-table-column align="center" width="160px" label="出院日期" prop="dischargeDate">
      <template slot-scope="{ row }">{{ row.dischargeDate | fmtDatetime  }}</template>
    </el-table-column>
    <el-table-column align="center" label="分组" prop="groupType"></el-table-column>
    <el-table-column align="center" label="办案单位" prop="caseUnit"></el-table-column>
    <el-table-column align="center" label="诊断" prop="diagnosis" show-overflow-tooltip>
      <template slot-scope="{ row }">
        {{ row.diagnosis }}
      </template>
    </el-table-column>
    <el-table-column align="center" label="外出原因" prop="outReason" show-overflow-tooltip>
      <template slot-scope="{ row }">
        {{ row.outReason }}
      </template>
    </el-table-column>
    <creator :title="title" :patientList="patientList" :entity="entity" @ok="page" :visible.sync="meta.editor">
    </creator>
  </hic-list-page>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  components: {
    creator: () => import('./creator'),
  },
  data() {
    return {
      title: "",
      entity: {},
      value: {},
      meta: {
        loading: false,
        editor: false,
      },
      condition: {
        // date: "",
        keyword: "",
        sort: "id",
        asc: false,
        pageSize: 10,
        pageIndexOnView: 1,
      },
      selectDate: '',
      entities: {
        items: [],
      },
      patientList: [],
    };
  },
  computed: {
    ...mapGetters(["dict", "getDict", "dictEnum", "Enum", "permission", "user"]),
  },
  methods: {
    page() {
      this.patents()
      this.meta.loading = true;
      api.OutMedicalRecord.query(this.condition)
        .then((res) => {
          this.entities = res;
        })
        .catch((err) => {
          this.$message.error(err || err.message);
        })
        .finally((f) => {
          this.meta.loading = false;
        });
    },
    changeDate(val) {
      console.log(val)
      if (val) {
        this.condition.outDateSt = this.$utils.Fmt.date(val[0]) + ' 00:00:00'
        this.condition.outDateEd = this.$utils.Fmt.date(val[1]) + ' 23:59:59'
      } else {
        this.condition.outDateSt = null
        this.condition.outDateEd = null
      }
      this.page()
    },
    create(type, row) {
      this.title = type == 'new' ? '新增外出就诊信息' : '修改外出就诊信息'
      if(row && row.outDate) row.outDate = this.$utils.Fmt.datetime(row.outDate)
      if(row && row.dischargeDate) row.dischargeDate = this.$utils.Fmt.datetime(row.dischargeDate)
      this.entity = row ? this.$utils.Obj.clone(row) : {}
      this.meta.editor = true
    },

    del(row) {

      api.OutMedicalRecord.del(row.id)
        .then((res) => {
          this.$message.success("删除成功!");
          this.page();
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    patents() {
      let con = {
        state: "已入住",
        ifShowOwnDept: true,
        pageSize: 1000,
        deptCode: this.user.deptCode,
        sort: "bedNo",
        asc: true,
      }
      api.Hospitalization.query(con)
        .then((res) => {
          this.patientList = res.items;
          if (this.title.indexOf('修改') > -1) {
            console.log(this.entity)

          }
        })
        .catch((err) => {
          this.$message.error(err || err.message);
        })
        .finally((f) => {
        });
    },
  },
};
</script>

<style scoped></style>
